// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__TL9Uz","main":"Footer_main__2gPMm","second":"Footer_second__+BGz+"};